import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"

export type DeliveryOrderExportStatus = {
  roomJid: string
  deliveryOrderId: string
  status: string
  errorMessage?: string
  externalId?: string
  syncedAt?: string
  driverName?: string
  carPlates?: string
  vatId?: string
}

// Keyed by the driver's room JID (the pubsub item id)
export type DeliveryOrderExportStatusesState = Record<
  string,
  DeliveryOrderExportStatus
>

const initialState: DeliveryOrderExportStatusesState = {}

type UpsertDeliveryOrderExportStatusAction = {
  exportStatus: DeliveryOrderExportStatus
}

type BatchUpsertDeliveryOrderExportStatusesAction = {
  exportStatuses: DeliveryOrderExportStatus[]
}

const deliveryOrderExportStatuses = createSlice({
  name: "deliveryOrderExportStatuses",
  initialState,
  reducers: {
    upsertDeliveryOrderExportStatus: (
      state,
      action: PayloadAction<UpsertDeliveryOrderExportStatusAction>,
    ) => {
      state[action.payload.exportStatus.roomJid] = action.payload.exportStatus
    },
    removeDeliveryOrderExportStatus: (
      state,
      action: PayloadAction<{ roomJid: string }>,
    ) => {
      delete state[action.payload.roomJid]
    },
    batchUpsertDeliveryOrderExportStatuses: (
      state,
      action: PayloadAction<BatchUpsertDeliveryOrderExportStatusesAction>,
    ) => {
      for (const exportStatus of action.payload.exportStatuses) {
        state[exportStatus.roomJid] = exportStatus
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const {
  upsertDeliveryOrderExportStatus,
  removeDeliveryOrderExportStatus,
  batchUpsertDeliveryOrderExportStatuses,
} = deliveryOrderExportStatuses.actions

export default deliveryOrderExportStatuses.reducer
